import formatProductIdBing from './utils/formatProductIdBing';
var pageView = function pageView(_ref) {
  var _structure$route, _data$search, _data$search$term, _data$product, _structure$route2;
  var structure = _ref.structure,
    data = _ref.data;
  window.uetq = window.uetq || [];
  var pageId = structure == null ? void 0 : structure.id;
  var categoryId = structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.categoryId;
  var searchTerm = data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$term = _data$search.term) == null ? void 0 : _data$search$term.refined;
  var bingProductId = formatProductIdBing(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.variationId);
  var subCategoryId = structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.subCategoryId;
  var ecommType = {
    category: {
      ecomm_category: categoryId,
      ecomm_pagetype: 'category'
    },
    home: {
      ecomm_pagetype: 'home'
    },
    other: {
      ecomm_pagetype: 'other'
    },
    product: {
      ecomm_pagetype: 'product',
      ecomm_prodid: bingProductId
    },
    search: {
      ecomm_pagetype: 'searchresults',
      ecomm_query: searchTerm
    },
    subcategory: {
      ecomm_category: "".concat(categoryId, "-").concat(subCategoryId),
      ecomm_pagetype: 'category'
    }
  };
  var ecommParams = ecommType[pageId] || ecommType.other;
  window.uetq.push('event', '', ecommParams);
};
export default pageView;